import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="payment-cancel-page">
      <header className="bg-white border-b border-slate-200 py-4 px-6">
        <div className="max-w-7xl mx-auto flex items-center gap-2">
          <Activity className="w-7 h-7 text-blue-600" />
          <span className="text-xl font-bold text-slate-900" style={{ fontFamily: 'Chivo, sans-serif' }}>Vital</span>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-md w-full text-center" data-testid="cancel-content">
          <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <ArrowLeft className="w-10 h-10 text-orange-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Chivo, sans-serif' }}>
            Pagamento Cancelado
          </h1>
          <p className="text-slate-600 mb-8">
            Você cancelou o pagamento. Sem problemas! Volte quando estiver pronto para escolher seu plano.
          </p>
          <Button
            onClick={() => navigate(-1)}
            data-testid="go-back-btn"
            className="bg-slate-900 hover:bg-slate-800 text-white px-8"
            size="lg"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar aos Planos
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
